import { render, staticRenderFns } from "./PastTimeline.vue?vue&type=template&id=754051aa&scoped=true&"
import script from "./PastTimeline.vue?vue&type=script&lang=js&"
export * from "./PastTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PastTimeline.vue?vue&type=style&index=0&id=754051aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754051aa",
  null
  
)

export default component.exports